(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6900],{

/***/ 5885:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookies",
      function () {
        return __webpack_require__(1134);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Cookies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var _business_finland_wif_ui_lib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7720);
/* harmony import */ var _business_finland_wif_ui_lib_dist_PageHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9792);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);




var __N_SSG = true;
function Cookies() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_business_finland_wif_ui_lib_dist_PageHeader__WEBPACK_IMPORTED_MODULE_2__/* .PageHeader */ .m, {
                heading: "Cookie Policy",
                leadText: "Find information on how workinfinland.com uses cookies",
                backgroundColor: "lightBlue"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_business_finland_wif_ui_lib__WEBPACK_IMPORTED_MODULE_3__.B, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_business_finland_wif_ui_lib__WEBPACK_IMPORTED_MODULE_3__.B.Content, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CookieDeclaration, {})
                })
            })
        ]
    });
}
function CookieDeclaration() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (ref.current) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.id = "CookieDeclaration";
            script.src = "https://consent.cookiebot.com/f68f035c-7edf-41b7-a7d3-9f0b0f96401f/cd.js";
            ref.current.appendChild(script);
        }
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "CookieDeclarationCont",
        ref: ref
    });
}


/***/ }),

/***/ 9792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ E; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(403);
/* harmony import */ var _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7720);



const i = "page-header", H = "page-header--blue", m = "page-header--light-blue", u = "page-header__heading", h = "desktop", B = "page-header__lead-text", t = {
  pageHeader: i,
  pageHeaderBlue: H,
  pageHeaderLightBlue: m,
  pageHeaderHeading: u,
  desktop: h,
  pageHeaderLeadText: B
};
function E({
  heading: n,
  leadText: r,
  backgroundColor: o,
  children: g,
  className: l,
  ...s
}) {
  const c = o === "lightBlue" ? t.pageHeaderLightBlue : t.pageHeaderBlue;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B,
    {
      "data-testid": "page-header",
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(t.pageHeader, c, l),
      topPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.SMALL,
      ...s
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, { itemScope: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.pageHeading, t.pageHeaderHeading) }, n)),
    r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, { itemScope: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
          _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitle,
          t.pageHeaderLeadText
        )
      },
      r
    )),
    g ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, null, g) : null
  );
}

//# sourceMappingURL=PageHeader.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(5885); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);